import React from "react";
import {RefreshButton, Show, Typography} from "@pankod/refine-antd";
import {IResourceComponentsProps, useShow} from "@pankod/refine-core";
import {ICategory} from "./model";

const { Title, Text } = Typography;

const metaData = {
    fields: [
        "id",
        "title",
    ],
};

export const CategoryShow: React.FC<IResourceComponentsProps> = () => {
    const { queryResult } = useShow<ICategory>({
        metaData,
    });
    const { data, isLoading } = queryResult;
    const record = data?.data;

    return (
        <Show isLoading={isLoading} headerProps={{ extra: <RefreshButton metaData={metaData} />}}>
            <Title level={5}>Id</Title>
            <Text>{record?.id}</Text>

            <Title level={5}>Title</Title>
            <Text>{record?.title}</Text>
        </Show>
    );
};
